import React from "react";
import { Button, Grid } from "@mui/material";
import { checkRoles } from "../../functions/checkRoles";
import { confirmDialog } from "../Dialog/DialogDelete";
import {
  REQUEST_STATE_ID_COMPLETED,
  REQUEST_STATE_ID_RESEARCH,
} from "../../redux/constants/requestStateConstants";

export async function runRequestRollback(crud, row, { onSuccess, onError } = {}) {
  try {
    const result = await crud.workflowRun(
      row?.id,
      REQUEST_STATE_ID_COMPLETED,
      REQUEST_STATE_ID_RESEARCH
    );

    if (result?.isRequestLocked) {
      onError?.("Тарификатор заблокирован");
      return;
    }

    if (result?.isProtocolsNotSigned || result?.isProtocolsNotPartiallySigned) {
      onError?.("Протокол не подписан");
      return;
    }

    await onSuccess?.();
  } catch (e) {
    onError?.(e?.message || String(e));
  }
}

export function getRequestRollbackColumn(crud, { reload, isRowEligible } = {}) {
  const canRollback = checkRoles("SuperAdministrator", "Administrator");
  if (!canRollback) {
    return null;
  }

  return {
    title: "Действия",
    dataIndex: "rollbackActions",
    key: "rollbackActions",
    render: (_, row) => {
      if (row?.state?.code !== REQUEST_STATE_ID_COMPLETED) {
        return null;
      }

      if (isRowEligible && !isRowEligible(row)) {
        return null;
      }

      return (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Button
              color="info"
              onClick={() => {
                confirmDialog(
                  "Откат заявки",
                  "Вы действительно хотите откатить эту заявку на исследование?",
                  async () => {
                    await runRequestRollback(crud, row, {
                      onSuccess: reload,
                      onError: (message) => alert(message),
                    });
                  }
                );
              }}
            >
              Откатить
            </Button>
          </Grid>
        </Grid>
      );
    },
  };
}

export function appendRequestRollbackColumn(columns, crud, options = {}) {
  const column = getRequestRollbackColumn(crud, options);
  if (column) {
    columns.push(column);
  }
  return columns;
}

export function isPaidActRow(row) {
  if (row?.orderType != null) {
    return Number(row.orderType) === 1;
  }

  return row?.number && String(row.number)[0] === "1";
}
